import React from 'react'
import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import ActivityContent from '../ActivityContent'
import ActivityEvents from '../ActivityEvents'
import ActivityDot from '../ActivityDot'
import ActivityOwner from '../ActivityOwner'

export default function QuoteErrorActivity(props: ActivityTypeComponentProps) {
  const { activity } = props
  const showDocTypeDetails = true
  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        <Highlight>Message Error</Highlight>
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      {activity.details.events?.length > 0 && (
        <ActivityContent>
          <ActivityEvents events={activity.details.events} />
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
